module.exports = __webpack_public_path__ + "img/ai2@2x.371d0ec0.png";